module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/B1mhI/tc-custom/9781534326361.jpg?1729186463979",
      "alt": "This image is the cover for the book Ice Cream Man Vol 8: Subjects & Objects, Ice Cream Man"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ice Cream Man Vol 8: Subjects & Objects, Ice Cream Man\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Open wide for four more scoops of the bestselling critically acclaimed psycho-horror comic ICE CREAM MAN.  Here bound with medium-grade paper glue are four tales of objective subjectivity: a man's last wishes are carried out; a controlled experiment loses all control; a cosmic scale is balanced (in verse!); Doug tries his darndest to get clean.  It's another assemblage of anguish and ennui for the anthologically-inclined art appreciator.  Lickety split y'all!   Collects ICE CREAM MAN #29-32")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W. Maxwell Prince, Martín Morazzo, Chris O'Halloran\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Image Comics\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0